import React from "react";
import Process from "../components/Process";

const ProcessDetails = ({ pageRef }) => {
  return (
    <div ref={pageRef}>
      <br></br>
      <br></br>
      <br></br>
      <br></br>
      <h1 style={{ textAlign: "center", color: "white" }}>
        COMPETITION DETAILS
      </h1>
      <br></br>
      <br></br>
      <Process />
    </div>
  );
};

export default ProcessDetails;
